import React from 'react';
import { Button } from '@mui/material';
import '@fontsource/open-sans'; // Ensure the font is installed and imported

/**
 * MassMemory100gb component renders a button that represents 100 GB of mass memory.
 * When clicked, it passes the value 100 to the onClick handler.
 * 
 * @component
 * @param {Object} props - The properties object.
 * @param {string} props.text - Text to display on the button.
 * @param {string} props.variant - The button's variant (e.g., 'contained', 'outlined').
 * @param {string} props.color - The button's color (e.g., 'primary', 'secondary').
 * @param {Function} props.onClick - Function called when the button is clicked, receives 100 as an argument.
 */
const MassMemory100gb =  ({ text, variant, color, onClick }) => {
  return (
    <Button
      size="small"
      variant={variant || 'outlined'}
      color={color || 'primary'}
      onClick={() => onClick(100)}  // Passes 100 to the onClick handler when clicked
      sx={{
        fontFamily: 'Open Sans',
        color: '#363636',
        width: { xs: '100%', sm: '100%', md: '90%' }, // Responsive width
        height: { xs: 'auto', sm: '40px' }, // Responsive height
        padding: '10px 20px', // Button padding
        margin: '0 10px', // Margin between buttons
        textTransform: 'none',
        whiteSpace: 'normal',  // Allows text to wrap to the next line
        wordWrap: 'break-word', // Breaks long words into multiple lines
        overflow: 'hidden', // Prevents overflow of content
        fontSize: '16px' // Fixed font size
      }}
    >
      {text || '100 GB'}
    </Button>
  );
};

export default MassMemory100gb;
